import React, { FC, ReactNode, useContext, useEffect, useRef } from "react";

import { UIActionContext } from "../../contexts/UIActionContext";

type Props = {
  id: string;
  children: ReactNode;
};

export const ScrollableSection: FC<Props> = ({ id, children }) => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const context = useContext(UIActionContext);

  if (!context) {
    throw new Error("ScrollableSection must be used within a ScrollProvider");
  }

  const { registerElement } = context;

  useEffect(() => {
    registerElement(id, sectionRef);
  }, [id, registerElement]);

  return <div ref={sectionRef}>{children}</div>;
};
